import attach from "@xingternal/360-styles"
import { onlyfyFullTheme, xingTheme } from "@xingternal/rebranding-adapter"

attach({
  "#root": { height: "100vh" },
  ".onlyfy-link": {
    color: onlyfyFullTheme.colors.blue8,
  },
  a: {
    color: onlyfyFullTheme.colors.blue8,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  ul: {
    marginBottom: 0,
  },
  input: {
    "&:hover": {
      borderColor: `${onlyfyFullTheme.colors.blue8} !important`,
    },
    "&:focus": {
      borderColor: `${onlyfyFullTheme.colors.blue8} !important`,
    },
  },
  // xbm - ebp
  ".company-profiles": {
    color: onlyfyFullTheme.colors.xbm,
  },
  ".border-company-profiles": {
    borderColor: onlyfyFullTheme.colors.xbm,
  },
  ".border-company-profiles-rebranded": {
    borderColor: "#D4699E",
  },
  ".background-company-profiles, .bg-company-profiles": {
    background: onlyfyFullTheme.colors.xbm,
  },
  // xtp
  ".talent-pool-manager": {
    color: onlyfyFullTheme.colors.xtp,
  },
  ".border-talent-pool-manager": {
    borderColor: onlyfyFullTheme.colors.xtp,
  },
  ".border-talent-pool-manager-rebranded": {
    borderColor: xingTheme.colors.xingLime2,
  },
  ".background-talent-pool-manager, .bg-talent-pool-manager": {
    background: onlyfyFullTheme.colors.xtp,
  },
  // xtm
  ".talent-manager": {
    color: onlyfyFullTheme.colors.xtm,
  },
  ".border-talent-manager": {
    borderColor: onlyfyFullTheme.colors.xtm,
  },
  ".border-talent-manager-rebranded": {
    borderColor: xingTheme.colors.mint,
  },
  ".background-talent-manager, .bg-talent-manager": {
    background: onlyfyFullTheme.colors.xtm,
  },
  // xjm
  ".job-manager": {
    color: onlyfyFullTheme.colors.xjm,
  },
  ".border-job-manager": {
    borderColor: onlyfyFullTheme.colors.xjm,
  },
  ".border-job-manager-rebranded": {
    borderColor: xingTheme.colors.xingPetrol2,
  },
  ".background-job-manager, .bg-job-manager": {
    background: onlyfyFullTheme.colors.xjm,
  },
  "[class^='DropdownInputTrigger']": {
    "&:hover": {
      borderColor: `${onlyfyFullTheme.colors.blue8} !important`,
    },
    "&:focus": {
      borderColor: `${onlyfyFullTheme.colors.blue8} !important`,
    },
  },
  ".dropdown_open > * > [class^='DropdownInputTrigger']": {
    borderColor: `${onlyfyFullTheme.colors.blue8} !important`,
  },
  "[class^='l-trigger-']": {
    "&:hover": {
      borderColor: `${onlyfyFullTheme.colors.blue8} !important`,
    },
    "&:focus": {
      borderColor: `${onlyfyFullTheme.colors.blue8} !important`,
    },
  },
  ".dropdown_open > * > [class^='l-trigger-']": {
    borderColor: `${onlyfyFullTheme.colors.blue8} !important`,
  },
  ".petrol-link": {
    color: `${onlyfyFullTheme.colors.blue8}`,
  },
  ".border-petrol-link ": {
    borderColor: `${onlyfyFullTheme.colors.blue8}`,
  },
  ".bg-petrol-link": {
    background: `${onlyfyFullTheme.colors.blue8}`,
  },
  ".background-petrol-link": {
    background: `${onlyfyFullTheme.colors.blue8}`,
  },
  "[class^='Menu-menuItem_active'] > .Menu-menuLink-1-2-32": {
    background: `${onlyfyFullTheme.colors.blue8} !important`,
  },
  "[class^='t-menuItem_active'] > .t-menuLink-1-2-32": {
    background: `${onlyfyFullTheme.colors.blue8} !important`,
  },
  ".background-petrol-light": {
    background: `${onlyfyFullTheme.colors.blue8} !important`,
  },
  ".bg-petrol-light": {
    background: `${onlyfyFullTheme.colors.blue8} !important`,
  },
  "[class^=h-pagination] [class*='l-icon-']": {
    fill: `${onlyfyFullTheme.colors.blue8} !important`,
  },
  "[id='date-range-xing-rebranded'] > ul > [ class^='Menu2-menuItem_active'] > .Menu2-menuLink-1-2-32":
    {
      background: `${xingTheme.colors.grey800} !important`,
    },
  "[id='date-range-xing-rebranded'] > ul > [ class^='t-menuItem_active'] > .t-menuLink-1-2-32":
    {
      background: `${xingTheme.colors.grey800} !important`,
    },
})
